// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Base from './layouts/Base/Base.vue';
import router from './router';
import { createStore } from "./store";
import 'es6-promise/auto';
Vue.config.productionTip = false;
/*initial vuex store*/
const store = createStore();
import vbclass from 'vue-body-class';
Vue.use(vbclass, router);
// make shuffle function globally available
Vue.prototype.$shuffleArray = function (array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
};
/* eslint-disable no-new */
new Vue({
    el: '#app',
    template: '<Base/>',
    router,
    components: { Base },
    store: store
});



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = null
// module chunks = 